export default __webpack_public_path__ + "static/media/ac_far.e991ef5f.bmp";